import { ADD_CART, REFRESH_CART, REMOVE_CART } from '../../constants';

export const cartReducer = (state, action) => {
    switch (action.type) {
        case ADD_CART: {
            const existingProductSku = state.cartItems.findIndex(item => item.skuId === action.payload.skuId);
            if (existingProductSku >= 0) {
                const updatedCart = state.cartItems.map(cartItem =>
                    cartItem.skuId === action.payload.skuId
                        ? { ...cartItem, quantity: cartItem.quantity + 1 }
                        : cartItem
                );
                console.log({ updatedCart, existingProductSku })
                return { ...state, cartItems: updatedCart };
            } else {
                return { ...state, cartItems: [...state.cartItems, { ...action.payload, quantity: 1 }] };
            }
        }
        case REMOVE_CART:
            return { ...state, cartItems: state.cartItems.filter(item => item.skuId !== action.payload.skuId) };

        case REFRESH_CART:
            return {
                ...state,
                cartItems: action.payload.cartItems
            };
        default:
            return state;
    }
};
